import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import VPN from './pages/VPN';
import CASB from './pages/CASB';
import About from './pages/About';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Healthcheck from './pages/Healthcheck';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/healthcheck" element={<Healthcheck />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="vpn" element={<VPN />} />
          <Route path="casb" element={<CASB />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route 
            path="admin" 
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } 
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
